import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
// API
import { getRecommendedBooks } from 'api/libros';
// Components
import Head from 'components/metatags_helmet/metatags';
import TitleWithLine from 'components/titleWithLine';
import ItemListRecommendedBook from 'components/ItemListRecommendedBook/item';
//styles
import '../awardWinningBooksPage/awardWinningBooksPage.scss';

const goUp = () => {
  window.scrollTo(0, 0);
};

const RecommendedBookstoresPage = () => {
  const [books, setBooks] = useState([]);
  const { t } = useTranslation(['home']);
  const title = t('recommendBookstores', { ns: 'backoffice' });

  useEffect(() => {
    async function fetchBooks() {
      const res = await getRecommendedBooks();
      if (res.status === 200) {
        setBooks(res.data.results || []);
      }
    }
    fetchBooks();
  }, []);

  useEffect(() => {
    goUp();
  }, []);

  return (
    <Container fluid className="margin-top-md px-4 d-flex mainDiv">
      <Head title={title} noIndex={true} />
      <Row className="awards">
        <Col lg={12}>
          <TitleWithLine text={title} />
        </Col>
        {books.length > 0 ? (
          books.map((book) => (
            <Col key={book.id} lg={2} className="margin-md">
              <ItemListRecommendedBook book={book} />
            </Col>
          ))
        ) : (
          <Col lg={12} className="text-center mt-4">
            <h3 className="text-muted">{t('noResults', { ns: 'backoffice' })}</h3>
          </Col>
        )}
      </Row>
    </Container>
  );
};

export default RecommendedBookstoresPage;
